export default "__VITE_ASSET__BG1IOcxs__"